import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GenericModal from '../GenericModal';

const ModalStyled = styled(GenericModal)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 500px;
  height: auto;
  padding: 20px 15px;
`

const Header = styled.div`
  font-size: 22px;
  font-weight: 600;
`
const SubHeader = styled.div`
  font-size: 12px;
  margin-top: 5px;
`
const Question = styled.div`
  font-size: 18px;
  margin-top: 20px;
  font-weight: 500;
`
const Answer = styled.div`
  font-size: 16px;
  margin-top: 10px;
`

const QuestionnaireModal = ({
  questions,
  header,
  subheader,
  children,
  ...other
}) => {

  return (
    <ModalStyled {...other}>
      <Header>{header}</Header>
      <SubHeader>{subheader}</SubHeader>
      {questions && questions.length > 0 && questions?.map((question, index) => (
        <div key={index}>
          <Question>Q: {question.question}</Question>
          {
            question.question_type === 'multiple_select' ?
             <Answer>A: {question.answer.join(", ")}</Answer> :
             <Answer>A: {question.answer}</Answer> 
          }
          
        </div>
      ))}
    </ModalStyled>
  );
}

QuestionnaireModal.propTypes = {
  header: PropTypes.string,
  subheader: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  value: PropTypes.object,
};

QuestionnaireModal.defaultProps = {
}

export default QuestionnaireModal;
